const css = `
:host {
  --default-delay: var(--upd-popup-transition-delay, 0.3s);

  display: block;
  position: relative;
}

.upd-popup-content {
  position: absolute;
  transform: translateX(-100vw);
  visibility: hidden;
  /* Fallback for browsers that don't support CSS Custom Properties */
  transition: transform 0s 0.3s, visibility 0s 0.3s;
  transition: transform 0s var(--default-delay),
    visibility 0s var(--default-delay);
}

:host([open]) .upd-popup-content {
  visibility: visible;
  transform: translateX(0);
  transition: transform 0s, visibility 0s;
  /* Fallback for browsers that don't support CSS Custom Properties */
  z-index: 90;
  z-index: 90;
  z-index: var(--upd-popup-z-index, 90);
}
`;

const TAG_NAME = 'upd-popup';

const template = document.createElement('template');
template.innerHTML = `
  <style>${css}</style>

  <div class="upd-popup-content">
    <slot></slot>
  </div>
`;

const HAS_SHADY_CSS = window.hasOwnProperty('ShadyCSS');
if (HAS_SHADY_CSS) {
  window.ShadyCSS.prepareTemplate(template, TAG_NAME);
}

class Popup extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  constructor() {
    super();

    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(template.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setAttribute('aria-hidden', !this.opened);

      if (!this.opened) {
        this.dispatchEvent(new Event('close'));
      }
    }
  }

  connectedCallback() {
    // Shim Shadow DOM styles. Needs to be run in connectedCallback.
    // Needed for IE 11.
    if (HAS_SHADY_CSS) {
      window.ShadyCSS.styleElement(this);
    }
  }

  get opened() {
    return this.hasAttribute('open');
  }

  open() {
    if (!this.opened) {
      this.setAttribute('open', '');
    }
  }

  close() {
    if (this.opened) {
      this.removeAttribute('open');
    }
  }
}

window.customElements.define(TAG_NAME, Popup);
